import { TConcessionaria } from '../../services';

export const addressFormatter = (dealer: TConcessionaria) => {
	const { logradouro, numeroLogradouro, complementoLogradouro, bairro, cidade, estado } = dealer;

	return `${logradouro}, ${numeroLogradouro}${
		complementoLogradouro ? `, ${complementoLogradouro}` : ''
	} - ${bairro}, ${cidade} - ${estado}`;
};
